import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  pageHelp: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(0.5),
  },
  formCard: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(10),
    padding: theme.spacing(3),
  },
  formHeader: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  formSubtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  sectionDescription: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  sectionHeadingRow: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  twoColumnGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  fieldSpacing: {
    marginBottom: theme.spacing(2),
  },
  statusRow: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  draftBadge: {
    backgroundColor: theme.palette.warning.light,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.warning.dark,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: 600,
    padding: theme.spacing(0.5, 1),
  },
  publishedVersion: {
    color: theme.palette.text.secondary,
  },
  stickyActions: {
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    bottom: 0,
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    marginLeft: -theme.spacing(3),
    marginRight: -theme.spacing(3),
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 3),
    position: 'sticky',
    zIndex: 2,
  },
  tooltipTrigger: {
    display: 'inline-flex',
  },
  tooltipMultiline: {
    whiteSpace: 'pre-line',
  },
  softDeleteNote: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.caption.fontSize,
    marginTop: theme.spacing(1),
  },
  forbiddenState: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  errorBanner: {
    marginTop: theme.spacing(3),
    textAlign: 'center',
  },
}));
